import { CaretDown, CaretUp } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { CommandFooterContainer, FooterItem } from "./style";

function CommandFooter() {
  const { t } = useTranslation("app", {
    keyPrefix: "CommandModal.CommandFooter",
  });
  return (
    <CommandFooterContainer>
      <FooterItem>
        <div>
          <CaretUp weight="fill"/>
        </div>
        <div>
          <CaretDown weight="fill" />
        </div>
        <span>{t("navigate")}</span>
      </FooterItem>
      <FooterItem>
        <div>Enter</div>
        <span>{t("open_market")}</span>
      </FooterItem>
      <FooterItem>
        <div>Esc</div>
        <span>{t("close_modal")}</span>
      </FooterItem>
    </CommandFooterContainer>
  );
}

export default CommandFooter;
